"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendRetargeting = void 0;
const utils_fetch_1 = __importDefault(require("@gcloud-npm/utils.fetch"));
const utils_enums_environment_1 = require("@gcloud-npm/utils.enums.environment");
const utils_monitoring_sonda_1 = __importDefault(require("@gcloud-npm/utils.monitoring.sonda"));
const utils_monitoring_get_uuid_1 = __importDefault(require("@gcloud-npm/utils.monitoring.get-uuid"));
const utils_adabyron_make_up_telco_path_name_1 = require("@gcloud-npm/utils.adabyron.make-up-telco-path-name");
const EVENT_NAME = "MISC.SEND_RETARGETING";
function sendRetargeting({ data, context: appContext, envName = `${process.env.NEXT_PUBLIC_ENV_NAME}`, idFront = "VT" }) {
    const { campaign, contactInfo, products, context, recaptchaToken, additionalInfo } = data;
    const myContext = Object.assign(Object.assign({}, appContext), { environment: (0, utils_enums_environment_1.findOutEnvByEnvName)(envName) });
    const { 'abs-layer': connectionData } = myContext.environment;
    const { endpoint: host } = connectionData;
    let URL_API = `${host}/movistar-layer/api/open/retargeting/v1/collect-info`;
    const idRequest = (0, utils_monitoring_get_uuid_1.default)(idFront, '', false);
    const sonda = new utils_monitoring_sonda_1.default({
        eventName: EVENT_NAME,
        context: myContext,
        uniqueId: `idPeticion=${idRequest}`,
        origin: utils_adabyron_make_up_telco_path_name_1.PROCESS_NAME.CLIENT,
    });
    const request = new utils_fetch_1.default({
        method: "POST",
        endpoint: URL_API,
        data: { campaign, contactInfo, products, context, additionalInfo, requestId: idRequest },
        headers: {
            "Content-Type": "application/json; charset=utf-8",
            Accept: "application/json",
            "X-Recaptcha-Token": recaptchaToken,
        },
        sonda,
        responseType: "text",
    });
    return request.makeRequest();
}
exports.sendRetargeting = sendRetargeting;
exports.default = sendRetargeting;
//# sourceMappingURL=index.js.map